import { render, staticRenderFns } from "./marketing-page-layout.vue?vue&type=template&id=61c666bc&scoped=true&"
import script from "./marketing-page-layout.vue?vue&type=script&lang=js&"
export * from "./marketing-page-layout.vue?vue&type=script&lang=js&"
import style0 from "./marketing-page-layout.vue?vue&type=style&index=0&id=61c666bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c666bc",
  null
  
)

export default component.exports